/// <amd-module name="Search/WorkItem/Flux/Stores/SnippetFragmentCache" />
export interface IHighlightFragment {
    refName: string;

    name: string;
    
    highlights: string[];
}